import {
    ApiVaultDeposit,
    ApiVaultDepositResponse,
    LendingVaultInfoResponseApi,
    ParsedLendingVaultApi,
    ParsedLendingVaultInfoApi,
    ParsedVaultRewardsScheduleApi
} from "../api/vault";
import {
    LendingVaultsInfoResponse,
    ParsedLendingVault,
    ParsedLendingVaultInfo,
    ParsedVaultRewardsSchedule,
    VaultDeposit,
    VaultDepositResponse
} from "../domain/vault";
import { parseStrategyInfoFromApi, parseStrategyInfoUsdFieldsFromApi } from "./strategy-pareser";

function parseParsedLendingVaultFromApi(api: ParsedLendingVaultApi): ParsedLendingVault {
    return {
        address: api.address,
        vaultIdentifier: api.vaultIdentifier,
        nonce: api.nonce,
        manager: api.manager,
        principalMint: api.principalMint,
        lpMint: api.lpMint,
        lpSupply: Number(api.lpSupply),
        cumulativePrincipalDeposited: Number(api.cumulativePrincipalDeposited),
        maxEarlyUnstakeFee: Number(api.maxEarlyUnstakeFee),
        tags: api.tags,
        depositsEnabled: api.depositsEnabled,
        featured: api.featured,
        mintEnabled: api.mintEnabled
    };
}

function parseVaultRewardsScheduleFromApi(api: ParsedVaultRewardsScheduleApi): ParsedVaultRewardsSchedule {
    return {
        id: api.id,
        vaultAddress: api.vaultAddress,
        rewardMint: api.rewardMint,
        totalWeightedStakeSupply: api.totalWeightedStakeSupply, // stays as string
        rewardStartTime: Number(api.rewardStartTime),
        rewardEndTime: Number(api.rewardEndTime),
        emissionsPerSecond: api.emissionsPerSecond, // stays as string
        totalEmissionsAmount: Number(api.totalEmissionsAmount),
        rewardIndex: api.rewardIndex, // stays as string
        scheduleIndex: api.scheduleIndex,
        emissionsClaimed: Number(api.emissionsClaimed),
        createdAt: Number(api.createdAt),
        lastRewardIndexUpdateTime: Number(api.lastRewardIndexUpdateTime),
        durationStakeWeights: api.durationStakeWeights,
        synthetic: api.synthetic ?? false
    };
}

function parseLendingVaultInfoFromApi(api: ParsedLendingVaultInfoApi): ParsedLendingVaultInfo {
    return {
        vault: parseParsedLendingVaultFromApi(api.vault),
        vaultMetadata: api.vaultMetadata,
        vaultStrategy: parseStrategyInfoFromApi(api.vaultStrategy),
        // Present only with includeStrategySummaries; undefined preserved when the backend omits it.
        strategySummary: api.strategySummary ? parseStrategyInfoUsdFieldsFromApi(api.strategySummary) : undefined,
        vaultRewardsSchedules: api.vaultRewardsSchedules.map(parseVaultRewardsScheduleFromApi),
        vaultRewardsEmittedAmounts: api.vaultRewardsEmittedAmounts,
        totalOutstandingLoanCollateralValueUsd: api.totalOutstandingLoanCollateralValueUsd
    };
}

export function parseLendingVaultInfoResponseFromApi(api: LendingVaultInfoResponseApi): LendingVaultsInfoResponse {
    return {
        lendVaults: api.lendVaults.map(parseLendingVaultInfoFromApi),
        total: Number(api.total)
    };
}

function parseVaultDepositFromApi(api: ApiVaultDeposit): VaultDeposit {
    return {
        ...api,
        totalLpShares: Number(api.totalLpShares),
        availableLpShares: Number(api.availableLpShares),
        collateralLpShares: Number(api.collateralLpShares)
    };
}

export function parseVaultDepositResponseFromApi(api: ApiVaultDepositResponse): VaultDepositResponse {
    return {
        ...api,
        items: api.items.map(parseVaultDepositFromApi)
    };
}
